const goToFirstInvalid = () => {
  document.querySelector('.is-invalid')?.scrollIntoView({ behavior: 'smooth' });
};

(() => {
  'use strict';

  const forms = document.querySelectorAll<HTMLFormElement>(
    '.js-needs-validation',
  );

  Array.from(forms).forEach((form) => {
    form.addEventListener(
      'submit',
      (event: Event) => {
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
        }

        form.classList.add('was-validated');
        goToFirstInvalid();
        document
          .querySelector('.js-needs-validation :invalid')
          ?.scrollIntoView({ behavior: 'smooth' });
      },
      false,
    );
  });
})();

goToFirstInvalid();
